import alertService from '../services/alert.service'
import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import {
  Markup,
  StageUnit,
  Type
} from '../views/LabelBuilder/LabelBuilder.slice'

type LabelableType = 'site' | 'contact' | 'contactSite' | 'item'

export interface LabelData {
  id: number
  siteId: number
  labelableId: number
  markup: Markup
  createdBy: number
  updatedBy: number
  deletedBy?: number
  labelableType: LabelableType
  type: Type
  active: boolean
  contactName?: string
}

interface LabelSizeResponseData {
  width: number
  height: number
  unit: StageUnit
  type?: Type
}

export interface LabelReadByMarkupRequest {
  markup: Markup
}

export interface ReadSystemLabelRequest {
  id: number
  labelableType: string
}

export interface LabelCreateRequest {
  markup: Markup
  active: boolean
}

export interface LabelSnapshotRequest {
  image : string
  id : number
}

export interface LabelUpdateRequest {
  id: Number
  markup: Markup
  active: boolean
}

interface LabelPreviewRequest {
  markup: Markup
}

interface LabelSizeRequest {
  type: Type
}

interface LabelCloneRequest {
  markup: Markup
}

type LabelSizeResponse = ResponseCallback<LabelSizeResponseData>

const routes = {
  readByMarkup: '/labels/readByMarkup',
  readSystemLabelDetail: '/labels/readSystemLabelDetail',
  delete: '/labels/{id}',
  create: '/labels',
  update: '/labels/{id}',
  preview: '/labels/preview',
  size: '/labels/size',
  clone: '/labels/clone',
  snapshot: '/labels/snapshot',
}

export default {
  readByMarkup (payload: LabelReadByMarkupRequest, callback: ResponseCallback<LabelData>) {
    api.post(routes.readByMarkup, payload, callback)
  },

  readSystemLabelDetail (payload: ReadSystemLabelRequest, callback: ResponseCallback<LabelData>) {
    api.post(routes.readSystemLabelDetail, payload, callback)
  },

  delete (id: number, callback: ResponseCallback<LabelData>) {
    const url = routeUtil.replaceParams(routes.delete, { id })
    api.delete(url, {}, callback)
  },

  create (payload: LabelCreateRequest, callback: ResponseCallback<LabelData>) {
    api.post(routes.create, payload, callback)
  },

  saveLabelSnapshot (payload: LabelSnapshotRequest, callback: ResponseCallback<LabelData>) {
    api.post(routes.snapshot, payload, callback)
  },

  update (
    id: number,
    payload: LabelUpdateRequest,
    callback: ResponseCallback<LabelData>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.patch(url, payload, callback)
  },

  preview (payload: LabelPreviewRequest, callback: ResponseCallback<Markup>) {
    alertService.info('Label preview generating...')
    api.post(routes.preview, payload, callback)
  },

  size (payload: LabelSizeRequest, callback: LabelSizeResponse) {
    api.post(routes.size, payload, callback)
  },

  clone (payload: LabelCloneRequest, callback: ResponseCallback<LabelData>) {
    api.post(routes.clone, payload, callback)
  }
}
